import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
type Accent = 'mint' | 'amber' | 'slate';
interface CampaignSelectorProps {
  mode: number; // 0 = partial, 1 = single, 2+ = multiple
  onChange: (newMode: number) => void;
  accent?: Accent;
  maxCampaigns?: number;
}
const ACCENT_CLASSES: Record<Accent, {
  pill: string;
  arrow: string;
  arrowHover: string;
  label: string;
}> = {
  mint: {
    pill: 'border-[#7FE0C3]/30 bg-[#7FE0C3]/5',
    arrow: 'text-[#7FE0C3]/60',
    arrowHover: 'hover:bg-[#7FE0C3]/15 hover:text-[#7FE0C3]',
    label: 'text-[#7FE0C3]'
  },
  amber: {
    pill: 'border-amber-500/30 bg-amber-500/5',
    arrow: 'text-amber-400/60',
    arrowHover: 'hover:bg-amber-500/15 hover:text-amber-400',
    label: 'text-amber-400'
  },
  slate: {
    pill: 'border-slate-700 bg-slate-900/50',
    arrow: 'text-slate-500',
    arrowHover: 'hover:bg-slate-800 hover:text-slate-200',
    label: 'text-slate-200'
  }
};
function getLabel(mode: number): string {
  if (mode === 0) return 'Partial Campaign';
  if (mode === 1) return 'Single Campaign';
  return `${mode} Campaigns`;
}
export function CampaignSelector({
  mode,
  onChange,
  accent = 'slate',
  maxCampaigns = 10
}: CampaignSelectorProps) {
  const styles = ACCENT_CLASSES[accent];
  const canDecrement = mode > 0;
  const canIncrement = mode < maxCampaigns;
  return <div className="flex justify-center mb-12" data-id="element-51">
      <div className={`group relative flex items-center rounded-full border ${styles.pill} px-1 py-1 transition-all`} data-id="element-52">
        <button onClick={() => canDecrement && onChange(mode - 1)} disabled={!canDecrement} aria-label="Fewer campaigns" className={`w-9 h-9 rounded-full flex items-center justify-center transition-all ${styles.arrow} ${styles.arrowHover} opacity-0 group-hover:opacity-100 disabled:opacity-0 disabled:pointer-events-none`} data-id="element-53">
          <ChevronLeft className="w-5 h-5" data-id="element-54" />
        </button>

        <div className={`px-6 py-2 text-sm font-semibold uppercase tracking-wider min-w-[180px] text-center ${styles.label}`} data-id="element-55">
          {getLabel(mode)}
        </div>

        <button onClick={() => canIncrement && onChange(mode + 1)} disabled={!canIncrement} aria-label="More campaigns" className={`w-9 h-9 rounded-full flex items-center justify-center transition-all ${styles.arrow} ${styles.arrowHover} opacity-0 group-hover:opacity-100 disabled:opacity-0 disabled:pointer-events-none`} data-id="element-56">
          <ChevronRight className="w-5 h-5" data-id="element-57" />
        </button>
      </div>
    </div>;
}